import React, { useEffect, useState } from 'react';
import './RolesPermissionsTab.css';
import { TbUserEdit } from 'react-icons/tb';
import { Checkbox, Table, Modal, Input, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../Components/Loader/Loader';
import { MdOutlineDelete } from 'react-icons/md';
import { userManagement_roles_ActionHandler } from '../../../../Redux/Actions/user/UserManagementRoles';
import { userManagement_roles_list_ActionHandler } from '../../../../Redux/Actions/user/UserManagementRolesList';
import { userManagement_Update_roles_ActionHandler } from '../../../../Redux/Actions/user/UserManagementUpdateRoles';
import { userManagement_Create_roles_ActionHandler } from '../../../../Redux/Actions/user/UserManagementCreateRoles';
import { userManagement_Roles_Permission_Delete_Handler } from '../../../../Redux/Actions/user/UserManagementRoleDelete';
import Swal from 'sweetalert2';

const RolesPermissionsTab = () => {
    const [form] = Form.useForm();
    let dispatch = useDispatch();
    const [roleTitle, setRoleTitle] = useState([]);
    const [data, setData] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showAddRoleChanges, setShowAddRoleChanges] = useState(false);
    const [checkboxModified, setCheckboxModified] = useState(false);
    const [StateUpdateData, setStateUpdateData] = useState([]);
    const [showSaveBtn, setShowSaveBtn] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        dispatch(userManagement_roles_ActionHandler());
        dispatch(userManagement_roles_list_ActionHandler());
        // eslint-disable-next-line
    }, []);

    const userManagementRoles = useSelector(
        (state) => state?.userManagement_Roles_Data?.userManagement_roles_data
    );

    const userManagementRolesList = useSelector(
        (state) =>
            state?.userManagement_Roles_list_Data
                ?.userManagement_roles_list_data
    );

    const userManagementRolesCreate = useSelector(
        (state) =>
            state?.userManagement_Roles_create_Data
                ?.userManagement_roles_create_data
    );

    const userManagementRolesCreateLoader = useSelector(
        (state) => state?.userManagement_Roles_create_Data?.loader
    );

    const userManagementRolesUpdate = useSelector(
        (state) =>
            state?.userManagement_Roles_update_Data
                ?.userManagement_roles_update_data
    );

    const deletedRole = useSelector(
        (state) =>
            state?.userManagement_Roles_Delete_Data
                ?.userManagement_roles_delete_data
    );

    useEffect(() => {
        if (deletedRole) {
            setShowAddRoleChanges(false);
            dispatch(userManagement_roles_ActionHandler());
            dispatch(userManagement_roles_list_ActionHandler());
        }
    }, [deletedRole]);

    useEffect(() => {
        if (userManagementRolesCreate?.data) {
            setCheckboxModified(false);
            setShowAddRoleChanges(false);
            setShowSaveBtn(false);
            setLoader(true);
            setData([]);
            dispatch(userManagement_roles_ActionHandler());
            dispatch(userManagement_roles_list_ActionHandler());
        }
        // eslint-disable-next-line
    }, [userManagementRolesCreate?.data]);

    useEffect(() => {
        if (userManagementRolesUpdate?.message) {
            setShowSaveBtn(false);
            setLoader(true);
            setData([]);
            dispatch(userManagement_roles_ActionHandler());
            dispatch(userManagement_roles_list_ActionHandler());
        }
        // eslint-disable-next-line
    }, [userManagementRolesUpdate?.message]);

    useEffect(() => {
        if (userManagementRoles?.data || userManagementRolesList?.data) {
            setData(userManagementRolesList?.data);
            setRoleTitle(userManagementRoles?.data);
        }
        // eslint-disable-next-line
    }, [userManagementRoles, userManagementRolesList]);

    const fetchData = () => {
        if (roleTitle?.length) {
            const rows = data?.account_permissions?.map((permission) => {
                const row = {
                    key: permission?.id?.toString(),
                    permissions: permission?.name,
                };

                roleTitle?.forEach((role) => {
                    const roleId = role?.id?.toString();
                    row[roleId] = role?.permissions?.some(
                        (permis) => permis?.id === permission?.id
                    );
                });

                return row;
            });
            setTableData(rows);
        }
    };

    useEffect(() => {
        if (data?.account_permissions) {
            fetchData();
            setLoader(false);
        }
    }, [data, roleTitle]);

    const showModal = () => {
        setIsModalVisible(true);

        //gtm
        window.dataLayer.push({
            event: 'Create new role',
            buttonName: 'Create new role',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const onFinish = (values) => {
        const newRole = {
            id: roleTitle?.length + 1,
            name: values?.roleName,
            is_editable: true,
        };

        setRoleTitle([...roleTitle, newRole]);

        const updatedTableData = tableData?.map((record) => ({
            ...record,
            [newRole?.id.toString()]: false,
        }));

        setTableData(updatedTableData);

        setIsModalVisible(false);
        setShowAddRoleChanges(true);
        setCheckboxModified(true);

        form.resetFields();
    };

    const handleUpdateRoles = () => {
        dispatch(userManagement_Update_roles_ActionHandler(StateUpdateData));
    };

    const handleCheckboxChange = (key, roleId, checked) => {
        setShowSaveBtn(true);
        if (checkboxModified) {
            const updatedTableData = tableData?.map((record) => {
                if (record?.key === key) {
                    return {
                        ...record,
                        [roleId]: checked,
                    };
                }
                return record;
            });

            setTableData(updatedTableData);
        } else {
            const updatedTableData = tableData?.map((record) => {
                if (record?.key === key) {
                    return {
                        ...record,
                        [roleId]: checked,
                    };
                }
                return {
                    ...record,
                    [roleId]: record?.[roleId] || false,
                };
            });

            setTableData(updatedTableData);

            const updatedRoleData = updatedTableData
                ?.filter((record) => record[roleId])
                ?.map((record) => record?.key);

            const updatedRole = {
                id: roleId,
                name: roleTitle?.find((role) => role?.id === parseInt(roleId))
                    ?.name,
                permissions: updatedRoleData,
            };

            setStateUpdateData((prevRoles) => {
                const filteredRoles = prevRoles?.filter(
                    (prevRole) => prevRole.id !== roleId
                );
                return [...filteredRoles, updatedRole];
            });
        }
    };

    const handleDeleteRole = (roleId) => {
        if (roleId) {
            // const updatedRoleTitle = roleTitle?.filter((role) => role?.id !== roleId)

            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this role?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Role has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(
                        userManagement_Roles_Permission_Delete_Handler(roleId)
                    );
                }
            });
        }
        // setRoleTitle(updatedRoleTitle);
        // setShowAddRoleChanges(false);
    };

    const columns = [
        {
            title: 'Permissions',
            dataIndex: 'permissions',
            key: 'permissions',
            width: '250px',
            fixed: 'left',
            render: (_, record) => record?.permissions,
        },
        ...(Array.isArray(roleTitle)
            ? roleTitle?.map((role) => ({
                  title: (
                      <div className='addRole_delete-icon' key={role.id}>
                          {role?.name}
                          {role?.is_editable && role?.permissions && (
                              <MdOutlineDelete
                                  onClick={() => handleDeleteRole(role?.id)}
                              />
                          )}
                      </div>
                  ),
                  dataIndex: role?.id?.toString(),
                  key: role?.id?.toString(),
                  render: (text, record) => (
                      <div className='roles-permissions-checkbox-div'>
                          <Checkbox
                              className='form-custom-checkbox'
                              checked={record[role?.id.toString()]}
                              onChange={(e) =>
                                  role?.is_editable &&
                                  handleCheckboxChange(
                                      record?.key,
                                      role?.id?.toString(),
                                      e.target.checked
                                  )
                              }
                              // disabled={!role?.is_editable}
                          />
                      </div>
                  ),
              }))
            : []),
    ];

    const handleAddnewRoleApi = () => {
        const latestRoleId = roleTitle[roleTitle?.length - 1]?.id;

        // const selectedPermissions = tableData
        //   ?.filter((record) => record[latestRoleId])
        //   ?.map((record) => parseInt(record?.permissions?.slice(1)))
        //   ?.filter((permissionId) => !isNaN(permissionId));

        const selectedPermissions = tableData
            ?.filter((record) => record[latestRoleId])
            ?.map((record) => record?.key);

        const newRole = {
            name: roleTitle?.find((role) => role?.id === latestRoleId)?.name,
            permissions: selectedPermissions || [],
        };
        dispatch(userManagement_Create_roles_ActionHandler(newRole));
        // setShowAddRoleChanges(false);
    };

    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data?.permissions
    );

    return (
        <>
            <div>
                {(userManagementRolesCreateLoader || loader) && <Loader />}
                <div className='roles-permissions-container'>
                    <div className='roles-permissions-main_1'>
                        <div className='relative search-container'></div>
                        <div className='roles-permissions-main'>
                            <div>
                                {/* {userProfileData &&
                                userProfileData[11]?.slug ? (
                                    <button
                                        className='active-roles-permissions permission-disabled'
                                        disabled={true}>
                                        Add new role
                                    </button>
                                ) : ( */}
                                <div className='roles-permissions-parent9'>
                                    {showSaveBtn && !checkboxModified ? (
                                        <button
                                            className='active-roles-permissions'
                                            onClick={handleUpdateRoles}>
                                            Save Changes
                                        </button>
                                    ) : !showAddRoleChanges ? (
                                        <button
                                            className='active-roles-permissions'
                                            onClick={showModal}>
                                            <TbUserEdit />
                                            Add New Role
                                        </button>
                                    ) : (
                                        <button
                                            className='active-roles-permissions'
                                            onClick={handleAddnewRoleApi}>
                                            <TbUserEdit /> Add
                                        </button>
                                    )}
                                </div>
                                {/* )} */}
                            </div>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        bordered
                        size='middle'
                        className='mytable'
                        pagination={false}
                        scroll={{ x: 10 }}
                    />
                </div>

                <Modal
                    title='Add New Role'
                    visible={isModalVisible}
                    onOk={true}
                    onCancel={handleCancel}
                    className='user-mananement-model'>
                    <Form onFinish={onFinish} form={form}>
                        <Form.Item
                            label='Role Name'
                            name='roleName'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the role name!',
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <button
                                type='submit'
                                className='model-btn-submit-management'>
                                Add Role
                            </button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </>
    );
};

export default RolesPermissionsTab;
